/* Copyright (C) Okahu Inc 2023-2024. All rights reserved.*/

import { useContext } from 'react';
import { KahuContext } from '@/context';

export const useKahu = () => {
  const context = useContext(KahuContext);

  if (!context) throw new Error('useKahu must be used within a KahuProvider');

  return context;
};
